import { object, string } from 'yup';

export const formValidation = object({
    email: string().required("E-mail é obrigatório").email("E-mail inválido"),
});